(function(library, $) {
	$(function(){
        $(".serp_gal").on("click",function() {
			var viewTypeValue = $(this).val();
			var currentUrl = window.location.search;
            currentUrl = library.removeUrlParameter(currentUrl,"viewType");
            var finalUrl = currentUrl + '&viewType=' + viewTypeValue;

            window.location.search = finalUrl;
		});
	});

	return library;
}(MODULE || {}, jQuery));